import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaWhatsapp, FaFacebook, FaMoon } from 'react-icons/fa';
import { motion } from 'framer-motion';
import '../styles/components/Footer.scss';

const Footer = () => {
  const year = new Date().getFullYear();
  
  const socialLinks = [
    { icon: <FaInstagram />, url: 'https://www.instagram.com/lunapijamas3/', label: 'Instagram' },
    { icon: <FaWhatsapp />, url: 'https://wa.me/5516992613356', label: 'WhatsApp' },
    { icon: <FaFacebook />, url: 'https://lunapijamas.store/', label: 'Facebook' }
  ];
  
  const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.8,
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 }
  };
  
  return (
    <footer className="footer">
      <div className="container">
        <motion.div 
          className="footer-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={footerVariants}
        >
          <motion.div className="footer-logo" variants={itemVariants}>
            <Link to="/">
              <div className="logo-container">
                <FaMoon className="moon-icon" />
                <h2>Luna Pijamas</h2>
              </div>
              <p className="tagline">Conforto e estilo para suas noites</p>
            </Link>
          </motion.div>
          
          <motion.div className="footer-links" variants={itemVariants}>
            <h3>Links Rápidos</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/produtos">Pijamas</Link></li>
              <li><Link to="/sobre">Sobre</Link></li>
              <li><Link to="/contato">Contato</Link></li>
            </ul>
          </motion.div>
          
          <motion.div className="footer-social" variants={itemVariants}>
            <h3>Siga-nos</h3>
            <div className="social-links">
              {socialLinks.map((link, index) => (
                <a 
                  href={link.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label={link.label}
                  key={index}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          viewport={{ once: true }}
        >
          <p>&copy; {year} Luna Pijamas. Todos os direitos reservados.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 